import React, { useEffect } from 'react'

import '../Styles/Components/AppModal.scss';

export default function AppModal(props) {

    useEffect(() => {
        window.onclick = function (event) {
            if (event.target.id === "AppModal") {
                onHide();
            }
        }
        return () => {

        }
    })

    const onHide = () => {
        props.onHide();
    }

    return (
        <div className="AppModal" id="AppModal" >

            <div className={`AppModal--Content ${props.className}`}>
                {props.hasCloseBtn ? <img src="/images/x_icon.png" alt="modal close button" className="AppModal--Close-Btn" onClick={props.onHide} /> : null}
                {props.children}
            </div>

        </div>
    )
}
